import Vue from 'vue'
import Vuex from 'vuex'

import { AESencrypt, AESdecrypt, userSession, themeSession } from '@/modules/crypto'

import app from '@/app.js'

import defaults from '@/modules/default'
import interfacecfg from '@/modules/interface'
import tableheaders from './modules/tableheaders'
import sndAlerts from '@/modules/sounds'

import socket from './modules/socket'
import router from './modules/router'
import getters from './modules/getters'

Vue.use(Vuex)

const language = defaults.language
const userdata = userSession(app)
const theme = themeSession(app)

let store = new Vuex.Store({
  state: {
    app,
    interfacecfg,
    language,
    options: [],
    login: {
      logged: JSON.parse(AESdecrypt(localStorage.getItem('logged'), app) || false) || false,
      auth: AESdecrypt(localStorage.getItem('aa'), app),
      iv: AESdecrypt(localStorage.getItem('aw'), app),
      logged_user: {
        id: userdata.id || 0,
        name: userdata.name || '',
        function: userdata.function || '',
        permissions: userdata.permissions || []
      },
      theme: {
        dark: theme.dark,
        light: theme.light
      },
      preferences: JSON.parse(localStorage.getItem('preferences') || false) || { ...defaults.blank.preferences }
    },
    data: {
      orders: [],
      categories: [],
      items: [],
      catalog: [],
      schedules: { groups: [], all: [] },
      financial: {},
      employees: [],
      additional: [],
      customers: [],
      historic: [],
      users: [],
      users_permissions: [],
      notifications: []
    },
    global: {
      search: { ...defaults.search },
      filters: { ...defaults.filters },
      defaults: {
        blank: { ...defaults.blank },
        options: { ...defaults.options }
      }
    }
  },
  mutations: {
    setInterface (state, data) {
      for (var key in data) {
        state.interfacecfg[key] = data[key]
      }
    },
    snackBar (state, { type, message }) {
      var color = ''
      switch (type) {
        case 1:
          color = 'red'
          break
        case 2:
          color = 'green'
          break
      }
      state.interfacecfg.snackbar = {
        active: true,
        message: message,
        color: color
      }
    },
    async setLogin (state, { logged, auth, iv }) {
      localStorage.setItem('logged', await AESencrypt(JSON.stringify(logged), app, 1))
      localStorage.setItem('aa', await AESencrypt(auth, app, 1))
      localStorage.setItem('aw', await AESencrypt(iv, app, 1))
      state.login.logged = logged
      state.login.auth = auth
      state.login.iv = iv
    },
    async setUser (state, userdata) {
      localStorage.setItem('session', await AESencrypt(JSON.stringify(userdata), app, 1))
      state.login.logged_user.id = userdata.id
      state.login.logged_user.name = userdata.name
      state.login.logged_user.function = userdata.function
      state.login.logged_user.permissions = JSON.parse(await AESdecrypt(userdata.permissions, app, 1))[0]
    },
    async userLogout (state) {
      document.cookie.split(';').forEach(function (c) { document.cookie = c.replace(/^ +/, '').replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/') })
      localStorage.setItem('logged', await AESencrypt(JSON.stringify(false), app, 1))
      localStorage.setItem('session', await AESencrypt(JSON.stringify(false), app, 1))
      localStorage.setItem('aa', '')
      localStorage.setItem('aw', '')
      state.login.logged = false
      state.login.auth = ''
      state.login.iv = ''
      state.login.logged_user.id = 0
      state.login.logged_user.name = ''
      state.login.logged_user.function = ''
      state.login.logged_user.permissions = []
    }
  },
  actions: {
    setInterface ({ commit }, data) {
      commit('setInterface', data)
    },
    setIsMobile ({ state }, data) {
      state.interfacecfg.is_mobile = data
    },
    setOverlay ({ state }, data) {
      state.interfacecfg.overlay = data
      state.interfacecfg.blocked = data
    },
    setGlobalSearch ({ state }, data) {
      for (var key in data) {
        Vue.set(state.global.search, key, data[key])
      }
    },
    setGlobalFilters ({ state }, data) {
      for (var key in data) {
        Vue.set(state.global.filters, key, data[key])
      }
    },
    snackBar ({ commit }, data) {
      commit('snackBar', data)
    },
    async userLogin ({ commit, dispatch }, { login, password }) {
      let toEncrypt = JSON.stringify({
        login: login,
        password: password
      })
      let encrypted = await AESencrypt(toEncrypt, app) || false
      if (encrypted) {
        commit('setInterface', { loading: true, overlay: true, login_loading: true })
        setTimeout(function () { commit('setInterface', { loading: false, overlay: false, login_loading: false }) }, 5400)
        let request = {
          protocol: 'LOGIN',
          auth: {
            aa: encrypted.encrypted,
            aw: encrypted.iv
          }
        }
        commit('setLogin', { logged: false, auth: encrypted.encrypted, iv: encrypted.iv })
        return dispatch('socket/sendSocket', request)
      }
    },
    userLogout ({ commit, state, dispatch }) {
      commit('setInterface', { loading: true, overlay: true })
      let request = {
        protocol: 'LOGOUT',
        auth: {
          aa: state.login.auth,
          aw: state.login.iv
        }
      }
      commit('setLogin', { logged: false, auth: '', iv: '' })
      return dispatch('socket/sendSocket', request)
    },
    loadData ({ commit, state, dispatch }) {
      if (state.login.logged && state.login.auth) {
        let request = {
          protocol: 'DATA',
          auth: {
            aa: state.login.auth,
            aw: state.login.iv
          }
        }
        return dispatch('socket/sendSocket', request)
      } else {
        commit('userLogout')
      }
    },
    saveData ({ state, dispatch }, { page, item, data }) {
      let request = {
        protocol: 'SAVE',
        auth: {
          aa: state.login.auth,
          aw: state.login.iv
        },
        call: {
          page: page,
          item: item,
          data: data
        }
      }
      return dispatch('socket/sendSocket', request)
    },
    saveAction ({ state, dispatch }, { page, item, type, ignoreResponseBar }) {
      let request = {
        protocol: 'ACTION',
        auth: {
          aa: state.login.auth,
          aw: state.login.iv
        },
        call: {
          page,
          item,
          type,
          ignoreResponseBar
        }
      }
      return dispatch('socket/sendSocket', request)
    },
    saveMixed ({ state, dispatch }, { page, type, data, ignoreResponseBar }) {
      console.log('saveMixed', { page, type, data, ignoreResponseBar })
      let request = {
        protocol: 'MIXED',
        auth: {
          aa: state.login.auth,
          aw: state.login.iv
        },
        call: {
          page,
          type,
          data,
          ignoreResponseBar
        }
      }
      return dispatch('socket/sendSocket', request)
    },
    loadCep ({ state, dispatch }, { cep }) {
      let request = {
        protocol: 'EXTERNAL_API',
        auth: {
          aa: state.login.auth,
          aw: state.login.iv
        },
        call: {
          type: 1,
          call: { cep },
          ignoreResponseBar: true
        }
      }
      return dispatch('socket/sendSocket', request)
    },
    loadAddress ({ state, dispatch }, { address, num, uf, city }) {
      let request = {
        protocol: 'EXTERNAL_API',
        auth: {
          aa: state.login.auth,
          aw: state.login.iv
        },
        call: {
          type: 2,
          call: { address, num, uf, city },
          ignoreResponseBar: true
        }
      }
      return dispatch('socket/sendSocket', request)
    },
    setTheme ({ state }, theme) {
      state.login.theme.dark = theme.dark
      state.login.theme.light = theme.light
      localStorage.setItem('theme', AESencrypt(JSON.stringify(theme), app, 1))
    },
    setPreferences ({ state }, data) {
      for (var key in data) {
        state.login.preferences[key] = data[key]
      }
      localStorage.setItem('preferences', JSON.stringify(state.login.preferences))
    },
    soundAlert (data) {
      let sound = sndAlerts[data] || false
      if (typeof this.state.login.preferences.sound !== 'undefined' && this.state.login.preferences.sound && sound) {
        sound.play()
      }
    }
  },
  getters: {
    getAppData (state) {
      return state.app
    },
    getInterface (state) {
      return state.interfacecfg
    },
    getTheme (state) {
      return state.login.theme
    },
    isMobile (state) {
      return state.interfacecfg.is_mobile
    },
    getLanguage (state) {
      return state.language
    },
    loginData (state) {
      return state.login
    },
    userData (state) {
      return state.login.logged_user
    },
    userPermissions (state) {
      return state.login.logged_user.permissions
    },
    getData (state) {
      return state.data
    },
    getOptions (state) {
      return state.options
    },
    getGlobal (state) {
      return state.global
    },
    getPreferences (state) {
      return state.login.preferences
    }
  },
  modules: {
    tableheaders,
    socket,
    router,
    getters
  }
})

export default store
